import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from '@angular/material';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { AreaService } from 'app/service/cliente/area.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { RelatorioService } from 'app/service/cliente/relatorio.service';
import { Observable } from 'rxjs';

import { NodeUserDialogComponent } from '../dialog/node-user-dialog/node-user-dialog.component';

@Component({
  selector: 'app-users-doc-type',
  templateUrl: './users-doc-type.component.html',
  styleUrls: ['./users-doc-type.component.scss'],
})
export class UsersDocTypeComponent implements OnInit {
  @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
  @ViewChild('usersPaginator') usersPaginator: MatPaginator;
  @ViewChild('usersAuthPaginator') usersAuthPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  nameEmpresa: String = '';
  tipos: any[] = [];
  nodesToEdit: any[] = [];
  isLoading = true;
  showUserTable = false;
  userIdSel = 0;
  nodeIdSel = 0;
  clienteId: number;
  usuarios: any[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  typesUsersToSave: any[] = [];
  usuariosAuth: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  dataSourceToEdit = new MatTableDataSource<any>([]);
  dataSourceUsers = new MatTableDataSource<any>([]);
  dataSourceUsersAuth = new MatTableDataSource<any>(this.usuariosAuth);
  displayedColumns = ['name', 'action'];
  dispColumnsNodeEdit = ['mode_btn', 'name', 'action'];
  tiposDialog: any[];
  usersDialog: any[];

  constructor(
    private route: ActivatedRoute,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private areaService: AreaService,
    private configFolderService: ConfigurarPastaServiceService,
    private router: Router,
    private relatorioService: RelatorioService,
    public dialog: MatDialog
  ) {
    this.route.params.subscribe(
      (params) => (this.clienteId = params['clienteId'])
    );
  }

  ngOnInit() {
    this.listarNomeEmpresa();
    this.getAlltipos();
    this.getUsuarios();
  }

  getUsuarios() {
    this.relatorioService.getUsuariosPorCliente(this.clienteId).subscribe(
      (data) => {
        this.usuarios = data.map((el) => ({ id: el.id, nome: el.nome }));
        this.usersDialog = this.usuarios;
        this.dataSourceUsers = new MatTableDataSource(this.usuarios);
        this.dataSourceUsers.paginator = this.usersPaginator;
        this.dataSourceUsersAuth.paginator = this.usersAuthPaginator;
        this.showUserTable = true;
      },
      (err) => {
        console.error(err);
        this.openSnackBar(
          'Erro ao buscar Usuários, tente novamente mais tarde',
          true
        );
      }
    );
  }

  goToVincularTipo() {
    this.router.navigate([`configurar-tipo-cliente/${this.clienteId}`]);
  }

  getAlltipos() {
    this.configFolderService.getAllTipos().subscribe(
      (dados) => {
        this.tipos = dados.map((el) => ({ 
          id: el.id,
          title: el.title,
          showOnlyToUser: false,
        }));
        
        this.tiposDialog = this.tipos;
        this.dataSource = new MatTableDataSource(this.tipos);
        this.dataSource.paginator = this.paginator;

        this.dataSourceToEdit = new MatTableDataSource(this.nodesToEdit);

        this.isLoading = false;
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          'Ocorreu um erro ao buscar Tipos Documentais',
          true
        );
      }
    );
  }

  aplicarFiltro(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  aplicarFiltroUser(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceUsers.filter = filter;
  }

  listarNomeEmpresa() {
    this.clienteService.nomeCliente(this.clienteId).subscribe(
      (data) => {
        this.nameEmpresa = data;
      },
      (err) => {
        console.error(err);
        this.nameEmpresa = err.error.text;
      }
    );
  }

  onChangeSelAll(check){
    if(check) {
      this.dataSourceToEdit.data.forEach(el => {
        el.showOnlyToUser = true;
      })
    } else {
      this.dataSourceToEdit.data.forEach(el => {
        el.showOnlyToUser = false;
      })
    }
  }

  // Adicionar e remover tipos documentais
  addNodeToEdit(item) {
    this.nodesToEdit.push(item);
    this.dataSourceToEdit.data = this.nodesToEdit;

    let index = this.tipos.indexOf(item);
    this.tipos.splice(index, 1);

    this.dataSource.data = this.tipos;
  }

  removeItemToEdit(item) {
    this.tipos.push(item);
    this.dataSource.data = this.tipos;

    let index = this.nodesToEdit.indexOf(item);
    this.nodesToEdit.splice(index, 1);

    this.dataSourceToEdit.data = this.nodesToEdit;
  }

  // Adicionar e remover Usuarios Autorizados
  setUserAuth(user) {
    this.usuariosAuth.push(user);

    let i = this.usuarios.indexOf(user);
    this.usuarios.splice(i, 1);

    this.dataSourceUsers.data = this.usuarios;
    this.dataSourceUsersAuth.data = this.usuariosAuth;
  }

  removeUserAuth(user) {
    this.usuarios.push(user);

    let i = this.usuariosAuth.indexOf(user);
    this.usuariosAuth.splice(i, 1);

    this.dataSourceUsers.data = this.usuarios;
    this.dataSourceUsersAuth.data = this.usuariosAuth;
  }

  onEditModeChange() {
    this.nodesToEdit.forEach((el) => {
      this.removeItemToEdit(el);
    });
    this.usuariosAuth.forEach((el) => {
      this.removeUserAuth(el);
    });
  }

  saveUsersAuth() {
    this.typesUsersToSave = [];
    this.isLoading = true;

    if (this.nodesToEdit.length > 0) {
      this.nodesToEdit.forEach((el) => {
        this.usuariosAuth.forEach((user) => {
          const typeUsersAuth = {
            nodeId: el.id,
            clientId: Number(this.clienteId),
            userId: user.id,
            showOnlyToUser: el.showOnlyToUser,
          };
          this.typesUsersToSave.push(typeUsersAuth);
        });
      });
    }
    this.callSaveMethod(
      this.configFolderService.setAuthUsersByType(
        this.typesUsersToSave,
        this.clienteId
      )
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }

  callSaveMethod(method: Observable<any[]>) {
    method.subscribe(
      () => {
        this.isLoading = false;
        this.openSnackBar('Alterações salvas com sucesso!', false);
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Ocorreu um erro ao salvar as alterações', true);
      }
    );
  }

  openDialog(isNodeEdit: boolean, isUserEdit: boolean, element: number): void {
    const dialogRef = this.dialog.open(NodeUserDialogComponent, {
      width: '100%',
      maxHeight: '95vh',
      data: {
        isNodeEdit: isNodeEdit,
        isUserEdit: isUserEdit,
        element: element,
        data: isNodeEdit
          ? this.usersDialog
          : isUserEdit
          ? this.tiposDialog
          : null,
        clienteId: this.clienteId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/users-doc-type-dialog/users-doc-type.component.ts